import { useLayoutEffect, useState } from 'react';

// İçerik (naturalWidth px) kapsayıcıdan genişse (lg+), sığacak şekilde orantılı küçültür
export function useFitZoom(naturalWidth) {
  const [outer, outerRef] = useState(null);
  const [zoom, setZoom] = useState(1);

  useLayoutEffect(() => {
    if (!outer) return undefined;
    const fit = () => {
      const avail = outer.clientWidth;
      const z = window.innerWidth >= 1024 && naturalWidth > avail ? Math.max(0.3, avail / naturalWidth) : 1;
      setZoom(Math.round(z * 1000) / 1000);
    };
    fit();
    const ro = new ResizeObserver(fit);
    ro.observe(outer);
    return () => ro.disconnect();
  }, [outer, naturalWidth]);

  return { outerRef, zoom };
}
